// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LanguageSwitcherModal-cls1___74be23f290ca6ba0570{/*!*/}.LanguageSwitcherModal-cls2___d6b64f94f11d50d14f7{color:#777;cursor:pointer;font-size:16px;position:absolute;top:20px;right:20px;background:none;border:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "LanguageSwitcherModal-cls1___74be23f290ca6ba0570",
	"cls2": "LanguageSwitcherModal-cls2___d6b64f94f11d50d14f7 LanguageSwitcherModal-cls1___74be23f290ca6ba0570"
};
export default ___CSS_LOADER_EXPORT___;
